'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.form-control-datepicker {\n  width: 100px !important;\n}\n\n.react-datepicker-popper {\n  \n}\n\n.react-datepicker {\n  font-size: 1.3rem !important;\n}\n\n.react-datepicker__current-month {\n  font-size: 1.5rem !important;\n}\n\n.react-datepicker__header {\n  padding-top: 6px !important;\n}\n\n.react-datepicker__navigation {\n  top: 13px !important;\n}\n\n.react-datepicker__day-name, .react-datepicker__day {\n  margin: 0.5rem !important;\n}\n\n';

// header

var DatePickerComponent = function DatePickerComponent(props) {
  var display = _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_reactCssComponent.ClientStyle, { css: css }),
    _react2.default.createElement(_reactDatepicker2.default, {
      id: 'select-date',
      selected: props.fromDate,
      onChange: props.handleDateChange,
      className: 'form-control-datepicker'
    })
  );

  return display;
};

exports.default = DatePickerComponent;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/elements/DatePicker.js
// module id = 868
// module chunks = 0